import { FlowStep, PolicyPackage } from "../../interfaces/altair";

interface CreateHandleSelectPackageParams {
  setSelectedPackageCode: (code: string) => void;
  setFlowStep: (step: FlowStep) => void;
  client: any;
}

export const createHandleSelectPackage =
  ({
    setSelectedPackageCode,
    setFlowStep,
    client,
  }: CreateHandleSelectPackageParams) =>
  (pkg: PolicyPackage) => {
    console.log("✅ [Ameen] User selected package:", pkg);
    setSelectedPackageCode(pkg.packageCode);
    // Don't change flowStep or send event - wait for confirm button
    // The confirm button will send the event and change flowStep
  };


